module.exports = __webpack_public_path__ + "static/media/warehouse.9f3aca1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warehouse.svg
// module id = 471
// module chunks = 1